module.exports = __webpack_public_path__ + "static/media/ONGC.970afe02.png";